import {
	ChangeDetectionStrategy,
	Component,
	OnInit,
	input,
	output,
	signal,
} from '@angular/core';
import { Sort } from '../../models/sort.models';
import { NgClass } from '@angular/common';
import {
	ArrowDownSvgComponent,
	SortArrowsSvgComponent,
	TickSvgComponent,
} from '@uc/shared/svg';
import { FormsModule } from '@angular/forms';
import { DropdownDirective } from '@uc/utilities';

@Component({
	selector: 'uc-sort-v1',
	templateUrl: './sort-v1.component.html',
	imports: [
		NgClass,
		FormsModule,
		DropdownDirective,
		SortArrowsSvgComponent,
		ArrowDownSvgComponent,
		TickSvgComponent,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SortV1Component implements OnInit {
	options = input.required<Sort[]>();
	defaultSelectedOption = input<Sort>();
	customStyles = input<string>('');
	buttonWidth = input<string>('w-auto');
	showSelectOnDesktop = input<boolean>(false);

	selectedOption = signal<Sort | undefined>(undefined);

	sort = output<Sort>();

	ngOnInit(): void {
		if (this.defaultSelectedOption()) {
			this.selectedOption.set(this.defaultSelectedOption());
			return;
		}

		this.selectedOption.set(this.options()[0]);
	}

	onSortSelect(option: Sort | undefined) {
		if (!option) return;

		this.selectedOption.set(option);
		this.sort.emit(option);
	}

	isSelected(option: Sort) {
		return (
			option.sortBy === this.selectedOption()?.sortBy &&
			option.sortDir === this.selectedOption()?.sortDir
		);
	}
}
